import { Skeleton } from 'antd'
import classnames from 'classnames'
import Link from 'next/link'

import urls from '@/config/uiUrls'

import { ComponentProps } from '@/types/components'
import { Project, ProjectType } from '@/types/index.d'

type ProjectLinkProps = {
  project: Project
  suffix?: string
  isLoading?: boolean
  width?: number
} & ComponentProps

function getProjectType(project: Project): ProjectType {
  if (project?.organization) {
    return 'ENVIRONMENT'
  } else {
    return 'GIT'
  }
}

export function ProjectLink({
  classNames,
  dataTestId,
  project,
  suffix,
  width = 60,
  isLoading = false,
}: ProjectLinkProps): JSX.Element {
  if (isLoading || !project)
    return (
      <Skeleton
        active={true}
        loading={isLoading}
        paragraph={false}
        title={{ width: width }}
      />
    )

  const projectType = getProjectType(project)

  return (
    <Link
      href={getProjectLink({ project, projectType, suffix })}
      className={classnames(classNames)}
      data-cy={dataTestId}
    >
      {project?.title}
    </Link>
  )
}

type projectLinkHref = {
  project: Project
  projectType: ProjectType
  suffix: string
}

export function getProjectLink({
  project,
  projectType,
  suffix,
}: projectLinkHref) {
  return [urls.projects.getProjectUrl(project?.id, projectType), suffix].join(
    ''
  )
}
